export default __webpack_public_path__ + "static/poster-87ad0dced2ebf9ec5d019f463215ee4b.png";